export default __webpack_public_path__ + "static/media/check-Ins.7b8ee814.svg";